/** UUID v4 pattern: 8-4-4-4-12 hex characters */
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Returns true if the value is a valid UUID string.
 */
export function isUuid(value) {
    if (!value || typeof value !== "string")
        return false;
    return UUID_REGEX.test(value.trim());
}
